import { createBrowserRouter } from 'react-router-dom';
import Home from '../Pages/Home/Home';
import Profile from '../Pages/Exhibitor/Profile/Profile';
import ProfileHomepage from '../Pages/Exhibitor/Profile/ProfileHomepage';
import SpaceRequirements from '../Pages/Exhibitor/Profile/SpaceRequirement/SpaceRequirements';
import ChangePassword from '../Pages/Exhibitor/Profile/ChangePassword';
import PrivateRoute from '../Components/PrivateRoute/PrivateRoute';
import ForgetPassword from '../Pages/Common/ForgetPassword/ForgetPassword';
import MatchOtp from '../Pages/Common/MatchOtp/MatchOtp';
import NewPassword from '../Pages/Common/NewPassword/NewPassword';
import VisitorLogin from '../Pages/Visitor/VisitorLogin/VisitorLogin';
import VisitorRegistration from '../Pages/Visitor/VisitorRegistration/VisitorRegistration';
import ProductAndServices from '../Pages/Exhibitor/Profile/ProductAndServices/ProductAndServices';
import OnlineVisitors from '../Pages/Exhibitor/Profile/OnlineVisitors/OnlineVisitors';
import RegisteredStaff from '../Pages/Exhibitor/Profile/RegisteredStaff/RegisteredStaff';
import VisitorProfile from '../Pages/Visitor/VisitorProfile/VisitorProfile';
import VisitorProfileHomePage from '../Components/Visitor/VisitorProfileHomePage/VisitorProfileHomePage';
import VisitorPrivateRoute from '../Components/PrivateRoute/VisitorPrivateRoute';
import VisitorEditProfile from '../Pages/Visitor/VisitorEditProfile/VisitorEditProfile';
import VisitorWishlist from '../Pages/Visitor/VisitorWishlist/VisitorWishlist';
import NotFound from '../Pages/NotFound/NotFound';
import MyLeads from '../Pages/Exhibitor/Profile/MyLeads/MyLeads';
import VisitorInvoice from '../Pages/Visitor/VisitorInvoice/VisitorInvoice';
import RegisteredEvents from '../Pages/Visitor/RegisteredEvents/RegisteredEvents';
import EventList from '../Pages/Event/EventList/EventList';
import SingleEvent from '../Pages/Event/SingleEvent/SingleEvent';
import B2BProfileHomePage from '../Pages/B2BBuyerSeller/B2B/B2BProfileHomePage';
import B2BProfile from '../Pages/B2BBuyerSeller/B2BProfile/B2BProfile';
import B2BPrivateRoute from '../Components/PrivateRoute/B2BPrivateRoute';
import B2BWishlist from '../Pages/Visitor/VisitorWishlist/VisitorWishlist';
import B2BInvoice from '../Pages/B2BBuyerSeller/B2BProfile/B2BInvoice';
import B2BChangePassword from '../Pages/B2BBuyerSeller/B2BProfile/B2BChangePassword';
import B2BRegisteredEvents from '../Pages/B2BBuyerSeller/B2BProfile/B2BRegistratedEvent';
import ExhibitorLogin from '../Pages/Exhibitor/Login/ExhibitorLogin';
import PublicProductAndServices from '../Pages/PublicProductAndServices/PublicProductAndServices';
import ExhibitorProductAndServiceDetails from '../Pages/PublicProductAndServices/ExhibitorProductAndServiceDetails';
import VisitorChangePassword from '../Pages/Visitor/VisitorChangePassword/VisitorChangePassword';
import BillingInfo from '../Pages/Exhibitor/Profile/BillingInfo';
import ViewSingleBilling from '../Pages/Exhibitor/Profile/Invoice/ViewSingleBilling';
import ExhibitorPublicPage from '../Pages/Exhibitor/ExhibitorPublicPage/ExhibitorPublicPage';
import ExhibitorRegistration from '../Pages/Exhibitor/ExhibitorRegistration/ExhibitorRegistration';
import AdditionalService from '../Pages/Exhibitor/Profile/AdditionalServices/AdditionalService';
import TicketingRequest from '../Pages/Visitor/TicketingRequest/TicketingRequest';
import B2BLogin from '../Pages/B2BBuyerSeller/B2BRegistration/B2BLogin';
import B2BRegistration from '../Pages/B2BBuyerSeller/B2BRegistration/B2BRegistration';
import SlotManagement from '../Pages/B2BBuyerSeller/B2BProfile/Slot/SlotManagement';
import AvailableSlotManage from '../Pages/B2BBuyerSeller/B2BProfile/AvailableSlot/AvailableSlotManage';
import OtherCompanysRequestSlotList from '../Pages/B2BBuyerSeller/B2BProfile/Slot/OtherCompanysRequestSlotList';
import MeetingManageMent from '../Pages/Exhibitor/Profile/MeetingRequestList/MeetingManageMent';
import CreateExhibitorMeeting from '../Pages/Exhibitor/Profile/MeetingRequestList/CreateExhibitorMeeting';
import ExhibitorMeetingRequest from '../Pages/Exhibitor/Profile/MeetingRequestList/ExhibitorMeetingRequest';
import BookingSystem from '../Pages/B2BBuyerSeller/B2BProfile/Slot/BookingSystem';
import ViewVisitorSingleBilling from '../Pages/Visitor/VisitorInvoice/ViewVisitorSingleBilling';
import ExhibitorPayment from '../Pages/Exhibitor/Payment/ExhibitorPayment';
import B2BBuyerSellerPayment from '../Pages/B2BBuyerSeller/Payment/B2BBuyerSellerPayment';
import VisitorPayment from '../Pages/Visitor/Payment/VisitorPayment';

export const routers = createBrowserRouter([
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: 'login',
    element: <ExhibitorLogin />,
  },
  {
    path: 'product-services',
    element: <PublicProductAndServices />,
  },
  {
    path: 'all-exhibitor',
    element: <ExhibitorPublicPage />,
  },
  {
    path: 'product-services',
    element: <PublicProductAndServices />,
  },
  {
    path: 'product-services/exhibitor/details/:id',
    element: <ExhibitorProductAndServiceDetails />,
  },
  {
    path: 'book-your-space',
    element: <ExhibitorRegistration />,
  },
  {
    path: 'visitor-login',
    element: <VisitorLogin />,
  },
  {
    path: 'visitor-login',
    element: <VisitorLogin />,
  },
  {
    path: 'b2b-login',
    element: <B2BLogin />,
  },
  {
    path: 'visitor-registration',
    element: <VisitorRegistration />,
  },
  {
    path: 'b2b-registration',
    element: <B2BRegistration />,
  },
  {
    path: 'event-list',
    element: <EventList />,
  },
  {
    path: 'event-list/:id',
    element: <SingleEvent />,
  },
  {
    path: 'profile',
    element: <PrivateRoute component={<Profile />} />,
    children: [
      {
        path: '/profile',
        element: <ProfileHomepage />,
      },
      {
        path: 'space-requirements',
        element: <SpaceRequirements />,
      },
      {
        path: 'billing-info',
        element: <BillingInfo />,
      },
      {
        path: 'view-billing-info/:id',
        element: <ViewSingleBilling />,
      },
      {
        path: 'product-and-services',
        element: <ProductAndServices />,
      },
      {
        path: 'additional-service',
        element: <AdditionalService />,
      },
      {
        path: 'my-leads',
        element: <MyLeads />,
      },
      {
        path: 'online-visitors',
        element: <OnlineVisitors />,
      },
      {
        path: 'register-visitors',
        element: <RegisteredStaff />,
      },
      {
        path: 'my-meeting-request',
        element: <ExhibitorMeetingRequest />,
      },
      {
        path: 'meeting-create',
        element: <CreateExhibitorMeeting />,
      },
      {
        path: 'available-slot/:id',
        element: <AvailableSlotManage />,
      },
      {
        path: 'meeting-request',
        element: <MeetingManageMent />,
      },
      {
        path: 'payment-management',
        element: <ExhibitorPayment />,
      },
      {
        path: 'change-password',
        element: <ChangePassword />,
      },
    ],
  },

  {
    path: 'visitor',
    element: <VisitorPrivateRoute component={<VisitorProfile />} />,

    children: [
      {
        path: '/visitor/profile',
        element: <VisitorProfileHomePage />,
      },

      {
        path: '/visitor/register-event',
        element: <RegisteredEvents />,
      },

      {
        path: '/visitor/ticketing-request',
        element: <TicketingRequest />,
      },
      {
        path: '/visitor/edit-profile',
        element: <VisitorEditProfile />,
      },
      {
        path: '/visitor/invoice',
        element: <VisitorInvoice />,
      },

      {
        path: 'view-billing-info/:id',
        element: <ViewVisitorSingleBilling />,
      },
      {
        path: '/visitor/wishlist',
        element: <VisitorWishlist />,
      },
      {
        path: 'payment-management',
        element: <VisitorPayment />,
      },
      {
        path: '/visitor/change-password',
        element: <VisitorChangePassword />,
      },
    ],
  },
  {
    path: 'b2b',
    element: <B2BPrivateRoute component={<B2BProfile />} />,
    children: [
      {
        path: 'profile',
        element: <B2BProfileHomePage />,
      },
      {
        path: '/b2b/register-event',
        element: <B2BRegisteredEvents />,
      },
      {
        path: '/b2b/wishlist',
        element: <B2BWishlist />,
      },
      {
        path: '/b2b/invoice',
        element: <B2BInvoice />,
      },
      {
        path: '/b2b/slot',
        element: <SlotManagement />,
      },
      {
        path: '/b2b/meeting-request',
        element: <BookingSystem />,
      },
      {
        path: '/b2b/other-b2b-slot-list',
        element: <OtherCompanysRequestSlotList />,
      },
      {
        path: '/b2b/available-slot/:id',
        element: <AvailableSlotManage />,
      },
      {
        path: 'payment-management',
        element: <B2BBuyerSellerPayment />,
      },
      {
        path: '/b2b/change-password',
        element: <B2BChangePassword />,
      },
    ],
  },

  {
    path: 'forget-password',
    element: <ForgetPassword />,
  },
  {
    path: 'match-otp',
    element: <MatchOtp />,
  },
  {
    path: 'new-password',
    element: <NewPassword />,
  },
]);
